import { convertPeriod, convertPeriodStr, fmtSmallNumber, noExponents, secondsLeftToUtc, secondsToHhMmSs, toK } from '@/utils'
import { isNull, isUndefined, startCase } from 'lodash'
import { onMounted, onUnmounted, ref } from 'vue'
import { useAutoRefresh } from './../useAutorefresh'
import { useTzDate } from '../useTzDate'

export function useSwapCellFormatter() {
  const formattingRules = ref({})
  const { now } = useTzDate()
  const { startRefresh, stopRefresh } = useAutoRefresh(async () => {
    updateRules()
  }, 1000)

  const updateRules = () => {
    formattingRules.value = {
      'symbol.name': (v: string) => {
        if (isUndefined(v) || isNull(v)) {
          return ''
        }
        return v.split('/')[0]
      },
      funding_spread: (v: number, ctx: Record<string, unknown>) => {
        if (isUndefined(v) || isNull(v)) {
          return '—'
        }

        if (ctx.period_long !== ctx.period_short) {
          return '!!!'
        }
        const periodLong = convertPeriod(ctx.period_long)
        const periodShort = convertPeriod(ctx.period_short)

        if (!periodLong || !periodShort) {
          return '???'
        }

        let rateSpread = Number(v).toFixed(2)
        if (v > 0) {
          rateSpread = `+${rateSpread}`
        }
        return `${rateSpread}%`
      },
      'ex_buy.name': startCaseV,
      'ex_sell.name': startCaseV,
      period_long: convertPeriodStr,
      period_short: convertPeriodStr,
      rate_long: rateFormatter,
      rate_short: rateFormatter,
      vol24h_buy: (v: number) => {
        return toK(v)
      },
      vol24h_sell: (v: number) => {
        return toK(v)
      },
      price_buy: (v: number | null) => {
        if (isNull(v) || isUndefined(v)) {
          return '—'
        }
        return fmtSmallNumber(v) ?? '—'
      },
      price_sell: (v: number | null) => {
        if (isNull(v) || isUndefined(v)) {
          return '—'
        }
        return fmtSmallNumber(v) ?? '—'
      },
      spread: (v: string) => {
        return Number(v).toFixed(2) + '%'
      },
      updated_at: (v: string) => {
        if (!v) {
          return '—'
        }
        const ts = new Date(v.endsWith('Z') || v.includes('+') ? v : v + 'Z').getTime()
        const seconds = Math.floor((now.value.getTime() - ts) / 1000)
        return secondsToHhMmSs(Math.max(0, seconds))
      },
    }
  }

  const rateFormatter = (v: string, ctx: Record<string, unknown>, field_name: string) => {
    const side = field_name.split('_')[1]
    if (!side) {
      return '—'
    }
    const period = ctx[`period_${side}`]
    const sexLeft = secondsLeftToUtc(period as string, new Date())
    if (!sexLeft || sexLeft < 0) {
      return '—'
    }
    return v
  }

  // форматирование данных в таблице
  const startCaseV = (v: string) => {
    if (isUndefined(v) || isNull(v)) {
      return ''
    }
    return startCase(v)
  }

  onMounted(() => {
    updateRules()
    startRefresh()
  })

  onUnmounted(() => {
    stopRefresh()
  })

  return { formattingRules }
}
